import React from 'react';

import { css } from 'glamor';

function FillHorizontal({ children }: { children: React.Element }) {
  return (
    <div
      {...css({
        display: 'flex',
        flexDirection: 'row',
      })}>
      {children}
    </div>
  );
}

FillHorizontal.Spacer = function Separator({ size = 8 }: { size: number }) {
  return (
    <div
      {...css({
        width: size,
        flexGrow: 1,
      })}
    />
  );
};

FillHorizontal.Separator = function Separator({ size = 8 }: { size: number }) {
  return (
    <div
      {...css({
        width: size,
        flexGrow: 0,
        flexShrink: 0,
      })}
    />
  );
};

export default FillHorizontal;



// WEBPACK FOOTER //
// ../src/client/components/layout/FillHorizontal.js